@if (!isLoading) {
  <div class="pl-2">
    <div class="flex items-center mb-2">
      <p-toggleswitch
        name="activation"
        inputId="centralizedDepartmentControl"
        [disabled]="isToggleDisabled"
        [formControl]="isCentralizedDepartmentControl"
        (change)="toggleSwitchChanged()"
      />
      <label class="pl-2" for="centralizedDepartmentControl">Centralized Intake Department Provider Admin</label>
    </div>
    @if (isToggleDisabled) {
      <p-message class="ml-12 w-128" severity="info" icon="pi pi-info-circle">
        <span class="text-xs">A user can be a Centralized Intake Department Provider Admin if they have at least one Provider of the Parent Company assigned to them.</span>
      </p-message>
    }
    @if (isCentralizedDepartmentControl.value && !isToggleDisabled) {
    <div>
      <p-select
        #companyDropdown
        [autofocusFilter]="true"
        [formControl]="companyControl"
        (onChange)="setCompany($event)"
        (onBlur)="onCompanyControlBlur()"
        placeholder="Select company"
        [options]="companiesOptions"
        appendTo="body"
      />
      <div class="error-container">
        @if (companyControl.invalid && companyControl.touched) {
          <small class="p-error">Required field</small>
        }
      </div>
    </div>
  }
  </div>
} @else {
  <div class="flex">
    <p-progressSpinner class="w-12! h-12!" />
  </div>
}
